import { FileType } from "@/types/baseTypes";
import { useRouter } from "next/router";
import React, { useState } from "react";
import styles from "./AudioItem.module.scss";
import { Button } from "@/components/Global/Button/Button.tsx";
import { AnimatePresence } from "motion/react";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

interface AudioItemProps {
  data: FileType;
}

function AudioItem({ data }: AudioItemProps) {
  const router = useRouter();
  const { getLabel } = useGlobalContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const transcriptId = `transcript-${data.id}`;

  const { has_transcript, transcript, captions } = data.acf || {};

  return (
    <section className={`${styles["audio-item"]}`}>
      <audio controls src={data.url} controlsList="nodownload">
        <track
          src={captions?.url}
          kind="captions"
          srcLang={router.locale ?? router.defaultLocale ?? "de"}
          label={router.locale ?? router.defaultLocale ?? "de"}
        />

        <p>{getLabel("audio-not-supported-label")}</p>
      </audio>

      {has_transcript && (
        <div className={styles["caption"]}>
          <Button
            onClick={() => setIsModalOpen(!isModalOpen)}
            type="primary"
            target=""
            href=""
            aria-label={getLabel("toggle-transcript-aria-label")}
            aria-expanded={isModalOpen}
            aria-controls={transcriptId}
          >
            {isModalOpen
              ? getLabel("hide_transcript")
              : getLabel("show_transcript")}
          </Button>
        </div>
      )}

      {transcript && (
        <AnimatePresence>
          {isModalOpen && (
            <div
              id={transcriptId}
              role="region"
              aria-live="polite"
              aria-label={getLabel("audio-transcript-aria-label")}
              dangerouslySetInnerHTML={{ __html: transcript }}
            />
          )}
        </AnimatePresence>
      )}
    </section>
  );
}

export default AudioItem;
